module.exports = __webpack_public_path__ + "img/李志军.f2a5501a.jpg";